import { RaModule } from 'resources/RaModule';
import { ResourceName, ResourceIntent } from 'shared/enums';

export const BatchesModule = RaModule.fromResourceProps({
  name: ResourceName.BATCHES,
  intent: ResourceIntent.REGISTRATION
});
